import React, { useState, useEffect } from "react";
import { Box, Typography, Grid,  Card, CardContent, TextField, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchBrands } from "../../Redux/Slice/brandSlice";
import Pagination from "../../Components/Pagination";

const Brand = () => {
  const dispatch = useDispatch();
  const { brands, loading, error } = useSelector((state) => state.brands);
  const [searchTerm, setSearchTerm] = useState("");
  const [dropdownValue, setDropdownValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const brandsPerPage = 6;

  useEffect(() => {
    dispatch(fetchBrands());
  }, [dispatch]);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleDropdownChange = (event) => {
    setDropdownValue(event.target.value);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  // Ensure brands is an array before applying filter
  const filteredBrands = Array.isArray(brands)
    ? brands.filter(
        (brand) =>
          brand.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (brand.description && brand.description.toLowerCase().includes(searchTerm.toLowerCase()))
      )
    : [];

  const indexOfLastBrand = currentPage * brandsPerPage;
  const indexOfFirstBrand = indexOfLastBrand - brandsPerPage;
  const currentBrands = filteredBrands.slice(indexOfFirstBrand, indexOfLastBrand);

  return (
    <Box sx={{ padding: 2, minHeight: "100vh" }}>
      <Typography variant="h4" gutterBottom>
        Brands
      </Typography>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, flexWrap: "wrap", gap: 2 }}>
        <TextField
          label="Search..."
          variant="outlined"
          value={searchTerm}
          onChange={handleSearch}
          sx={{ width: { xs: "100%", sm: "200px", md: "250px" }, height: "40px" }}
        />

        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          <FormControl sx={{ minWidth: { xs: "100%", sm: 200, md: 220 } }}>
            <InputLabel>Filter</InputLabel>
            <Select value={dropdownValue} onChange={handleDropdownChange} label="Filter">
              <MenuItem value="option1">Option 1</MenuItem>
              <MenuItem value="option2">Option 2</MenuItem>
              <MenuItem value="option3">Option 3</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>

      {loading ? (
        <Typography>Loading...</Typography>
      ) : error ? (
        <Typography color="error">Error: {error}</Typography>
      ) : (
        <>
          <Grid container spacing={2}>
            {currentBrands.length > 0 ? (
              currentBrands.map((brand) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={brand.id}>
                  <Card sx={{ textAlign: "center", border: "1px solid #e0e0e0", borderRadius: 2, p: 2 }}>
                    <Box
                      component="img"
                      src={brand.image.length > 0 ? brand.image[0] : "https://via.placeholder.com/150"}
                      alt={`${brand.name} logo`}
                      sx={{ height: 80, width: "auto", mx: "auto", mb: 2 }}
                    />
                    <CardContent>
                      <Typography variant="h6" fontWeight="bold">
                        {brand.name}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                        {brand.description || "No description available"}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Items: {brand.productCount || 0}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))
            ) : (
              <Typography>No brands available</Typography>
            )}
          </Grid>

          <Pagination totalPages={Math.ceil(filteredBrands.length / brandsPerPage)} currentPage={currentPage} onPageChange={handlePageChange} />
        </>
      )}
    </Box>
  );
};

export default Brand;
